import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { ngxZendeskWebwidgetModule } from 'ngx-zendesk-webwidget';
import { CoreModule } from '../core/core.module';
import { AnnouncementModalComponent } from './announcement-modal/announcement-modal.component';
import { CustomLibraryAnnouncementModalComponent } from './announcement-modal/custom-library-announcement-modal/custom-library-announcement-modal.component';
import { EquipmentAvailabilityWidgetModalComponent } from './announcement-modal/equipment-availability-widget-modal/equipment-availability-widget-modal.component';
import { HalomediaAnnouncementModalComponent } from './announcement-modal/halomedia-announcement-modal/halomedia-announcement-modal.component';
import { HealthAndSafetyAnnouncemnetModalComponent } from './announcement-modal/health-and-safety-announcemnet-modal/health-and-safety-announcemnet-modal.component';
import { ManageFacilityModalComponent } from './announcement-modal/manage-facility-modal/manage-facility-modal.component';
import { MandatoryFieldsModalComponent } from './announcement-modal/mandatory-fields-modal/mandatory-fields-modal.component';
import { MandatoryPosModalComponent } from './announcement-modal/mandatory-pos-modal/mandatory-pos-modal.component';
import { NavigationModalComponent } from './announcement-modal/navigation-modal/navigation-modal.component';
import { OnboardingModalComponent } from './announcement-modal/onboarding-modal/onboarding-modal.component';
import { SsoLogoutModalComponent } from './announcement-modal/sso-logout-modal/sso-logout-modal.component';
import { SubscriptionAnnouncementModalComponent } from './announcement-modal/subscription-announcement-modal/subscription-announcement-modal.component';
import { SurveyModalComponent } from './announcement-modal/survey-modal/survey-modal.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { CalendarDashboardComponent } from './calendar-dashboard/calendar-dashboard.component';
import { ContentTileComponent } from './content-tile/content-tile.component';
import { CookieBannerComponent } from './cookie-banner/cookie-banner.component';
import { DashboardAdHintComponent } from './dashboard/dashboard-ad-hint/dashboard-ad-hint.component';
import { DashboardAdComponent } from './dashboard/dashboard-ad/dashboard-ad.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { EnrolledSectionComponent } from './dashboard/enrolled-section/enrolled-section.component';
import { HaloMediaQuestionComponent } from './dashboard/halo-media-question/halo-media-question.component';
import { HeatmapHeaderComponent } from './dashboard/heatmap-header/heatmap-header.component';
import { HeatmapLegendComponent } from './dashboard/heatmap-legend/heatmap-legend.component';
import { HeatmapSnapShotComponent } from './dashboard/heatmap-snap-shot/heatmap-snap-shot.component';
import { AllMachinesAddedComponent } from './dashboard/heatmap/all-machines-added/all-machines-added.component';
import { HeatmapComponent } from './dashboard/heatmap/heatmap.component';
import { NotificationsComponent } from './dashboard/notifications/notifications.component';
import { StatsUsageComponent } from './dashboard/stats-usage/stats-usage.component';
import { DeprecatedBannerComponent } from './deprecated-banner/deprecated-banner.component';
import { IframeResizerDirective } from './directives/iframe-resizer.directive';
import { DoorBannerComponent } from './door-banner/door-banner.component';
import { EquipmentDistancingComponent } from './equipment-settings/health-and-safety/equipment-distancing/equipment-distancing.component';
import { ExerciserCleaningComponent } from './equipment-settings/health-and-safety/exerciser-cleaning/exerciser-cleaning.component';
import { HealthAndSafetyComponent } from './equipment-settings/health-and-safety/health-and-safety.component';
import { StaffCleaningComponent } from './equipment-settings/health-and-safety/staff-cleaning/staff-cleaning.component';
import { LfOnDemandClassesComponent } from './equipment-settings/lf-on-demand-classes/lf-on-demand-classes.component';
import { AddEquipmentComponent } from './facility/equipment/add-equipment/add-equipment.component';
import { AddOldEquipmentComponent } from './facility/equipment/add-old-equipment/add-old-equipment.component';
import { AddOnboardingEquipmentComponent } from './facility/equipment/add-onboarding-equipment/add-onboarding-equipment.component';
import { EquipmentComponent } from './facility/equipment/equipment.component';
import { GetWidgetComponent } from './facility/equipment/get-widget/get-widget.component';
import { WidgetStep3Component } from './facility/equipment/get-widget/widget-step3/widget-step3.component';
import { WidgetStep4Component } from './facility/equipment/get-widget/widget-step4/widget-step4.component';
import { ListComponent } from './facility/equipment/list/list.component';
import { ProductPageModalComponent } from './facility/equipment/product-page-modal/product-page-modal.component';
import { WidgetBannerComponent } from './facility/equipment/widget-banner/widget-banner.component';
import { FacilitySuccessModalComponent } from './facility/facility-success-modal/facility-success-modal.component';
import { FacilityComponent } from './facility/facility.component';
import { InformationFormComponent } from './facility/information-form/information-form.component';
import { DelinkComponent } from './facility/manage-facilities/delink/delink.component';
import { InviteFacilityComponent } from './facility/manage-facilities/invite-facility/invite-facility.component';
import { ManageFacilitiesComponent } from './facility/manage-facilities/manage-facilities.component';
import { SetLevelComponent } from './facility/manage-facilities/set-level/set-level.component';
import { TreeComponent } from './facility/manage-facilities/tree/tree.component';
import { AddRfidConfirmationModalComponent } from './facility/rfid/add-rfid-confirmation-modal/add-rfid-confirmation-modal.component';
import { AddRfidComponent } from './facility/rfid/add-rfid/add-rfid.component';
import { MembersComponent } from './facility/rfid/members/members.component';
import { RfidComponent } from './facility/rfid/rfid.component';
import { FormComponent } from './facility/rfid/table/form/form.component';
import { GridComponent } from './facility/rfid/table/grid/grid.component';
import { PaginationComponent } from './facility/rfid/table/pagination/pagination.component';
import { TableComponent } from './facility/rfid/table/table.component';
import { UseRfidComponent } from './facility/rfid/use-rfid/use-rfid.component';
import { AccessDescriptionComponent } from './facility/staff/access-description/access-description.component';
import { AddStaffComponent } from './facility/staff/add-staff/add-staff.component';
import { StaffPermissionComponent } from './facility/staff/staff-permission/staff-permission.component';
import { StaffComponent } from './facility/staff/staff.component';
import { PackagePricing } from './helpers/package-pricing';
import { JiraIssueCollectorComponent } from './jira-issue-collector/jira-issue-collector.component';
import { LeftNavigationComponent } from './left-navigation/left-navigation.component';
import { PostLoginBaseComponent } from './post-login-base/post-login-base.component';
import { PostLoginHeaderComponent } from './post-login-header/post-login-header.component';
import { PostLoginRoutingModule } from './post-login-routing.module';
import { PreviewModalComponent } from './preview-modal/preview-modal.component';
import { ProductInfoGridComponent } from './product-info-grid/product-info-grid.component';
import { ProfileMenuComponent } from './profile-menu/profile-menu.component';
import { ProfileComponent } from './profile/profile.component';
import { ScheduleUpdateModalComponent } from './schedule-update-modal/schedule-update-modal.component';
import { ScheduleUpdateComponent } from './schedule-update/schedule-update.component';
import { SelectFacilityComponent } from './select-facility/select-facility.component';
import { SelectWithCheckboxRadioComponent } from './select-with-checkbox-radio/select-with-checkbox-radio.component';
import { ShopComponent } from './shop/shop.component';
import { DownloadSoftwareComponent } from './software/download-software/download-software.component';
import { DownloadComponent } from './software/download/download.component';
import { LifescapeCoursesComponent } from './software/lifescape-courses/lifescape-courses.component';
import { RemoteUpdateComponent } from './software/remote-update/remote-update.component';
import { SoftwareComponent } from './software/software.component';
import { SuperFooterComponent } from './super-footer/super-footer.component';
import { TileComponent } from './tile/tile.component';
import { TrainingClassesComponent } from './training/training-classes/training-classes.component';
import { ZendeskSupportWidgetComponent } from './zendesk-support-widget/zendesk-support-widget.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ColorPickerModule } from 'ngx-color-picker';
import { DndModule } from 'ngx-drag-drop';
import { ImageCropperModule } from 'ngx-image-cropper';
import { DigitalcoachAnnouncementModalComponent } from './announcement-modal/digitalcoach-announcement-modal/digitalcoach-announcement-modal.component';
import { FacilityConnectAnnouncementModalComponent } from './announcement-modal/facility-connect-announcement-modal/facility-connect-announcement-modal.component';
import { FacilityConnectSessionExpiryModalComponent } from './announcement-modal/facility-connect-session-expiry-modal/facility-connect-session-expiry-modal.component';
import { LegalModalReconsentCmsModalComponent } from './announcement-modal/legal-modal-reconsent-cms-modal/legal-modal-reconsent-cms-modal/legal-modal-reconsent-cms-modal.component';
import { LfodModalComponent } from './announcement-modal/lfod-modal/lfod-modal.component';
import { ApiDocsComponent } from './api-docs/api-docs.component';
import { ConfirmationLegendComponent } from './confirmation-legend/confirmation-legend.component';
import { EnableEquipmentComponent } from './enable-equipment/enable-equipment.component';
import { AnnouncementComponent } from './equipment-settings/announcement/announcement.component';
import { AttractScreenComponent } from './equipment-settings/attract-screen/attract-screen.component';
import { ChooseEquipmentComponent } from './equipment-settings/choose-equipment/choose-equipment.component';
import { ConsolePreviewComponent } from './equipment-settings/console-preview/console-preview.component';
import { EntertainmentAppComponent } from './equipment-settings/entertainment/entertainment-app/entertainment-app.component';
import { EntertainmentComponent } from './equipment-settings/entertainment/entertainment.component';
import { EntertainmentInternetComponent } from './equipment-settings/entertainment/internet/entertainment-internet.component';
import { EntertainmentIptvComponent } from './equipment-settings/entertainment/iptv/entertainment-iptv.component';
import { ImageEditorComponent } from './equipment-settings/image-editor/image-editor.component';
import { ImageManagerComponent } from './equipment-settings/image-manager/image-manager.component';
import { PerformanceRunComponent } from './equipment-settings/performance-run/performance-run.component';
import { GeneralProductSettingsComponent } from './equipment-settings/setting/general-product-settings/general-product-settings.component';
import { SettingComponent } from './equipment-settings/setting/setting.component';
import { WorkoutProductSettingsComponent } from './equipment-settings/setting/workout-product-settings/workout-product-settings.component';
import { AddWorkoutDetailComponent } from './equipment-settings/workout/add-workout-detail/add-workout-detail.component';
import { DynamicWorkoutListBackgroundSvgPipe } from './equipment-settings/workout/dynamic-workout-list-background-svg.pipe';
import { DynamicWorkoutListSvgPipe } from './equipment-settings/workout/dynamic-workout-list-svg.pipe';
import { MinMaxValueConvertionPipe } from './equipment-settings/workout/minMaxValueConversion.pipe';
import { ParamListKeyTranslatePipe } from './equipment-settings/workout/param-list-key-translate.pipe';
import { WorkoutLibraryComponent } from './equipment-settings/workout/workout-library/workout-library.component';
import { WorkoutListComponent } from './equipment-settings/workout/workout-list/workout-list.component';
import { WorkoutComponent } from './equipment-settings/workout/workout.component';
import { ListColumnAccessCheckerPipe } from './facility/equipment/list/list-column-access-checker.pipe';
import { ManageRequestComponent } from './facility/manage-facilities/manage-request/manage-request.component';
import { PendingFacilitiesComponent } from './facility/manage-facilities/pending-facilities/pending-facilities.component';
import { ProductInfoComponent } from './facility/product-info/product-info.component';
import { StaffListComponent } from './facility/staff/staff-list/staff-list.component';
import { FeatureFlagsComponent } from './feature-flags/feature-flags.component';
import { MenuComponent } from './menu/menu.component';
import { MultiConsoleSelectorComponent } from './multiconsole-selector/multiconsole-selector.component';
import { MultifacilitySelectorTreeComponent } from './multifacility-selector-tree/multifacility-selector-tree.component';
import { MultifacilitySelectorComponent } from './multifacility-selector/multifacility-selector.component';
import { CustomPipesModule } from './pipes/custom.pipe.module';
import { SelectorsModule } from './selectors/selectors.module';
import { DtableRotationsComponent } from './service/equipment-rotations/dtable-rotations/dtable-rotations.component';
import { EquipmentRotationsComponent } from './service/equipment-rotations/equipment-rotations.component';
import { HistoryComponent } from './service/history/history.component';
import { JobOrderComponent } from './service/maintenance/job-order/job-order.component';
import { MaintenanceComponent } from './service/maintenance/maintenance.component';
import { ServiceComponent } from './service/service.component';
import { CompleteDialogComponent } from './service/share/complete-dialog/complete-dialog.component';
import { DismissDialogComponent } from './service/share/dismiss-dialog/dismiss-dialog.component';
import { HistoryDialogComponent } from './service/share/history-dialog/history-dialog.component';
import { StatsModule } from './stats/stats.module';
import { DigitalCoachComponent } from './subcriptions/digital-coach/digital-coach.component';
import { LifeFitnessOnDemandPremiumComponent } from './subcriptions/life-fitness-on-demand-premium/life-fitness-on-demand-premium.component';
import { PortalRedirectComponent } from './subcriptions/portal-redirect/portal-redirect.component';
import { SmartStrengthComponent } from './subcriptions/smart-strength/smart-strength.component';
import { ChallengesComponent } from './training/challenges/challenges.component';
import { ManageComponent } from './training/manage/manage.component';
import { PromoteComponent } from './training/promote/promote.component';
import { RetainComponent } from './training/retain/retain.component';
import { AddLogoComponent } from './video-library/customize-branding/add-logo/add-logo.component';
import { BannerComponent } from './video-library/customize-branding/banner/banner.component';
import { CategoryDisplayNameComponent } from './video-library/customize-branding/category-display-name/category-display-name.component';
import { CustomizeBrandingComponent } from './video-library/customize-branding/customize-branding.component';
import { UploadVideoLibraryComponent } from './video-library/upload-video-library/upload-video-library.component';
import { VideoInformationComponent } from './video-library/video-information/video-information.component';
import { VideoLibraryComponent } from './video-library/video-library.component';
import { WorkoutPreviewComponent } from './video-library/workout-preview/workout-preview.component';
import { ViewVideoCompatibilityComponent } from './view-video-compatibility/view-video-compatibility.component';
@NgModule({
  declarations: [
    SuperFooterComponent,
    PostLoginBaseComponent,
    LeftNavigationComponent,
    DashboardComponent,
    ShopComponent,
    ProfileComponent,
    FacilityComponent,
    LfOnDemandClassesComponent,
    AttractScreenComponent,
    BreadcrumbComponent,
    DeprecatedBannerComponent,
    SelectFacilityComponent,
    PostLoginHeaderComponent,
    ProfileMenuComponent,
    ProductInfoGridComponent,
    PreviewModalComponent,
    HeatmapComponent,
    HeatmapSnapShotComponent,
    HeatmapHeaderComponent,
    HeatmapLegendComponent,
    NotificationsComponent,
    TileComponent,
    ContentTileComponent,
    CalendarDashboardComponent,
    EnrolledSectionComponent,
    HaloMediaQuestionComponent,
    AllMachinesAddedComponent,
    StatsUsageComponent,
    DoorBannerComponent,
    AnnouncementModalComponent,
    NavigationModalComponent,
    MandatoryFieldsModalComponent,
    SsoLogoutModalComponent,
    CookieBannerComponent,
    MandatoryPosModalComponent,
    JiraIssueCollectorComponent,
    ZendeskSupportWidgetComponent,
    SurveyModalComponent,
    HalomediaAnnouncementModalComponent,
    FacilityConnectAnnouncementModalComponent,
    FacilityConnectSessionExpiryModalComponent,
    CustomLibraryAnnouncementModalComponent,
    SoftwareComponent,
    RemoteUpdateComponent,
    LifescapeCoursesComponent,
    DownloadSoftwareComponent,
    ScheduleUpdateComponent,
    ScheduleUpdateModalComponent,
    DownloadComponent,
    HealthAndSafetyComponent,
    EquipmentDistancingComponent,
    ExerciserCleaningComponent,
    StaffCleaningComponent,
    HealthAndSafetyAnnouncemnetModalComponent,
    TrainingClassesComponent,
    IframeResizerDirective,
    EquipmentAvailabilityWidgetModalComponent,
    GetWidgetComponent,
    WidgetStep3Component,
    WidgetStep4Component,
    OnboardingModalComponent,
    ManageFacilitiesComponent,
    ManageFacilityModalComponent,
    InformationFormComponent,
    InviteFacilityComponent,
    SetLevelComponent,
    DelinkComponent,
    RfidComponent,
    GridComponent,
    PaginationComponent,
    FormComponent,
    TableComponent,
    AddRfidComponent,
    MembersComponent,
    UseRfidComponent,
    TreeComponent,
    AddRfidConfirmationModalComponent,
    AddEquipmentComponent,
    EquipmentComponent,
    ListComponent,
    WidgetBannerComponent,
    FacilitySuccessModalComponent,
    AddOnboardingEquipmentComponent,
    AddOldEquipmentComponent,
    ProductPageModalComponent,
    SelectWithCheckboxRadioComponent,
    StaffComponent,
    AddStaffComponent,
    StaffPermissionComponent,
    SubscriptionAnnouncementModalComponent,
    DashboardAdComponent,
    DashboardAdHintComponent,
    PendingFacilitiesComponent,
    ManageRequestComponent,
    AccessDescriptionComponent,
    StaffListComponent,
    MenuComponent,
    MultifacilitySelectorComponent,
    MultifacilitySelectorTreeComponent,
    MultiConsoleSelectorComponent,
    ViewVideoCompatibilityComponent,
    ConfirmationLegendComponent,
    LifeFitnessOnDemandPremiumComponent,
    DigitalCoachComponent,
    SmartStrengthComponent,
    PortalRedirectComponent,
    ProductInfoComponent,
    ListColumnAccessCheckerPipe,
    AnnouncementComponent,
    EntertainmentComponent,
    EntertainmentAppComponent,
    EntertainmentInternetComponent,
    EntertainmentIptvComponent,
    SettingComponent,
    WorkoutComponent,
    AddWorkoutDetailComponent,
    WorkoutLibraryComponent,
    WorkoutListComponent,
    PerformanceRunComponent,
    ImageManagerComponent,
    ImageEditorComponent,
    ConsolePreviewComponent,
    ChooseEquipmentComponent,
    DigitalcoachAnnouncementModalComponent,
    ManageComponent,
    PromoteComponent,
    ChallengesComponent,
    RetainComponent,
    VideoLibraryComponent,
    UploadVideoLibraryComponent,
    WorkoutPreviewComponent,
    FeatureFlagsComponent,
    AddLogoComponent,
    GeneralProductSettingsComponent,
    WorkoutProductSettingsComponent,
    VideoInformationComponent,
    CustomizeBrandingComponent,
    BannerComponent,
    CategoryDisplayNameComponent,
    DynamicWorkoutListBackgroundSvgPipe,
    DynamicWorkoutListSvgPipe,
    MinMaxValueConvertionPipe,
    ParamListKeyTranslatePipe,
    LfodModalComponent,
    EnableEquipmentComponent,
    ServiceComponent,
    EquipmentRotationsComponent,
    DtableRotationsComponent,
    HistoryComponent,
    MaintenanceComponent,
    CompleteDialogComponent,
    HistoryDialogComponent,
    DismissDialogComponent,
    ApiDocsComponent,
    JobOrderComponent,
    LegalModalReconsentCmsModalComponent,
  ],
  imports: [
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    Ng2SearchPipeModule,
    CommonModule,
    PostLoginRoutingModule,
    StatsModule,
    CoreModule,
    NgbModule,
    ngxZendeskWebwidgetModule,
    NgxChartsModule,
    SelectorsModule,
    ColorPickerModule,
    DndModule,
    ImageCropperModule,
    RouterModule,
    BrowserAnimationsModule,
    CustomPipesModule,
  ],
  exports: [SuperFooterComponent, PostLoginBaseComponent, ZendeskSupportWidgetComponent],
  providers: [PackagePricing],
})
export class PostLoginModule {}
